import Navbar from "./Navbar";
import AboutSection from "./AboutSection";
import Footer from "./Footer";
import AboutContent from "./AboutContent";
import AboutPartner from "./AboutPartner";

const About = () => {
  return (
    <div className="relative">
      <div className="mx-4 sm:mx-8 md:mx-[6.88rem]">
        <Navbar />
      </div>

      <AboutSection />
      <AboutContent />
      <AboutPartner />
      <Footer />
    </div>
  );
};

export default About;
